<template>
  <v-app id="inspire">
    <v-content>
      <v-container>
        <v-layout>
          <form :action="pdfurl" target="_blank" method="post">
            <v-flex xs12 sm12 md12>
              <v-card class="pa-3">
                <v-toolbar flat>
                  <v-toolbar-title>介護記録印刷（PDF出力）</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-menu
                        v-model="kmenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="kaisi"
                            label="開始日付選択"
                            prepend-icon="event"
                            readonly
                            dense
                            name="kaisi"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="kaisi"
                          dense
                          locale="ja"
                          @input="kmenu = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>

                    <v-col>
                      <v-menu
                        v-model="smenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="syuryo"
                            label="終了日付選択"
                            prepend-icon="event"
                            readonly
                            dense
                            name="syuryo"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="syuryo"
                          dense
                          locale="ja"
                          @input="smenu = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-select
                        v-model="riid"
                        :items="riyousyas"
                        item-text="rimyoji"
                        item-value="id"
                        label="利用者"
                        name="riid"
                      ></v-select>
                    </v-col>

                    <v-col>
                      <v-select
                        v-model="stid"
                        :items="staffs"
                        item-text="staffname"
                        item-value="id"
                        label="担当者"
                        name="stid"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-btn @click="clear"> 検索条件クリア</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" type="submit">
                    <v-icon right>print</v-icon>
                    PDF出力</v-btn
                  >
                </v-card-actions>
                <v-alert
                  :value="alert"
                  type="error"
                  transition="scale-transition"
                >
                  {{ msg }}
                </v-alert>
              </v-card>
            </v-flex>
          </form>
        </v-layout>

        <v-snackbar v-model="snackbar" color="success" :timeout="2000">
          {{ msg }}
          <v-btn @click="snackbar = false">
            閉じる
          </v-btn>
        </v-snackbar>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Auth from "@/components/Auth"
import moment from "moment"
export default {
  mixins: [Auth],

  data: () => ({
    kmenu: false,
    kaisi: moment().format("YYYY-MM") + "-01",
    smenu: false,
    syuryo: moment().endOf("month").format("YYYY-MM-DD"),
    riid: "",
    stid: "",
    staffs: [],
    riyousyas: [],
    snackbar: "",
  }),
  computed: {
    pdfurl: function () {
      return this.url + "pdf-kaigokiroku.php"
    },
  },
  mounted() {
    this.getStaffs()
    this.getRiyousyas()
  },
  methods: {
    getStaffs() {
      this.$axios.get(this.url + "getStaffs.php").then((response) => {
        this.staffs = response.data
        this.staffs.unshift({ id: "", staffname: "全て" })
      })
    },
    getRiyousyas() {
      this.$axios.get(this.url + "getRiyousyas.php").then((response) => {
        this.riyousyas = response.data
        this.riyousyas.unshift({ id: "", rimyoji: "全て" })
      })
    },
    clear() {
      2
      this.kaisi = ""
      this.syuryo = ""
      this.riid = ""
      this.stid = ""
    },
  },
}
</script>

<style lang="stylus"></style>
